export default __webpack_public_path__ + "7d00ed7b32cf9ec265d16939799d4049.svg";